module.exports = __webpack_public_path__ + "static/img/haogongzuo.0943fa51.png";